import Swal from "sweetalert2";
const customFailAlert = (message) => {
    return Swal.fire({
      title: "FAILED",
      text: message,
      icon: "error",
      confirmButtonColor: "red",
      confirmButtonText: "OK",
    });
  };


  export default customFailAlert;
